import React from "react"
import styled from "styled-components"

import { Flex } from "components/box"
import { EyebrowSmall, PlainLink } from "components/text"

const Container = styled(Flex)`
  transition: ease-in 0.2s all;
  height: ${props => props.theme.space[6]};
`

const BodyContainer = styled(Container).attrs({
  bg: "paleAqua",
  py: 3
})`
  justify-content: center;
  align-items: center;
  text-align: center;
`

const LinkContainer = styled(PlainLink)`
  text-decoration: none;
  * {
    cursor: pointer;
  }
`

type PromotionBarProps = {
  text: Maybe<string>
  href?: string
}

const PromotionBar: React.FC<PromotionBarProps> = ({ text, href }) => {
  if (href) {
    return (
      <LinkContainer href={href}>
        <BodyContainer>
          <EyebrowSmall>{text}</EyebrowSmall>
        </BodyContainer>
      </LinkContainer>
    )
  }

  return (
    <BodyContainer>
      <EyebrowSmall>{text}</EyebrowSmall>
    </BodyContainer>
  )
}

export default PromotionBar
